<template>
  <div ref="domRef" :class="['base-card-info', marginBottom ? 'mb-0' : '']">
    <div class="info-card-title">
      {{ companyTypeText }}信息
    </div>
    <change-record-container>
      <template #before>
        <div class="left-list gap-y-[14px]">
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLegal?.legalName, baseInfo?.post?.companyLegal?.legalName)" class="item">
            <div class="label">
              {{ isCompany ? '法定代表人' : companyTypeText }}姓名
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyLegal?.legalName) ? '--' : baseInfo?.pre?.companyLegal?.legalName }}
            </div>
          </div>
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLegal?.legalPhone, baseInfo?.post?.companyLegal?.legalPhone)" class="item">
            <div class="label">
              {{ isCompany ? '法定代表人' : `${companyTypeText}联系` }}电话
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyLegal?.legalPhone) ? '--' : baseInfo?.pre?.companyLegal?.legalPhone }}
            </div>
          </div>
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLegal?.legalIdNo, baseInfo?.post?.companyLegal?.legalIdNo)" class="item">
            <div class="label">
              {{ isCompany ? '法定代表人' : `${companyTypeText}身份` }}证件号
            </div>
            <div class="value">
              {{ isNull(baseInfo?.pre?.companyLegal?.legalIdNo) ? '--' : baseInfo?.pre?.companyLegal?.legalIdNo }}
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyLegal?.idNoExpiryStartDate, baseInfo?.post?.companyLegal?.idNoExpiryStartDate) ||
              !deepEqualField(baseInfo?.pre?.companyLegal?.idNoExpiryEndDate, baseInfo?.post?.companyLegal?.idNoExpiryEndDate)" class="item"
          >
            <div class="label">
              证件有效期
            </div>
            <div class="value">
              <span>{{ isNull(baseInfo?.pre?.companyLegal?.idNoExpiryStartDate) ? '--' : baseInfo?.pre?.companyLegal?.idNoExpiryStartDate }}</span>
              <span> ~ </span>
              <span>{{ isNull(baseInfo?.pre?.companyLegal?.idNoExpiryEndDate) ? '--' : baseInfo?.pre?.companyLegal?.idNoExpiryEndDate }}</span>
              <span v-if="['29991231', '2999-12-31'].includes(baseInfo?.pre?.companyLegal?.idNoExpiryEndDate)">长期</span>
            </div>
          </div>
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLegal?.idNoFrontUrl, baseInfo?.post?.companyLegal?.idNoFrontUrl)" class="item">
            <div class="label">
              身份证人像面
            </div>
            <div class="value">
              <div class="id-card-box">
                <img :src="baseInfo?.pre?.companyLegal?.idNoFrontUrl">
              </div>
            </div>
          </div>
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLegal?.idNoBackUrl, baseInfo?.post?.companyLegal?.idNoBackUrl)" class="item">
            <div class="label">
              身份证国徽面
            </div>
            <div class="value">
              <div class="id-card-box">
                <img :src="baseInfo?.pre?.companyLegal?.idNoBackUrl">
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #after>
        <div class="left-list gap-y-[14px]">
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLegal?.legalName, baseInfo?.post?.companyLegal?.legalName)" class="item">
            <div class="label">
              {{ isCompany ? '法定代表人' : companyTypeText }}姓名
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyLegal?.legalName) ? '--' : baseInfo?.post?.companyLegal?.legalName }}
            </div>
          </div>
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLegal?.legalPhone, baseInfo?.post?.companyLegal?.legalPhone)" class="item">
            <div class="label">
              {{ isCompany ? '法定代表人' : `${companyTypeText}联系` }}电话
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyLegal?.legalPhone) ? '--' : baseInfo?.post?.companyLegal?.legalPhone }}
            </div>
          </div>
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLegal?.legalIdNo, baseInfo?.post?.companyLegal?.legalIdNo)" class="item">
            <div class="label">
              {{ isCompany ? '法定代表人' : `${companyTypeText}身份` }}证件号
            </div>
            <div class="value">
              {{ isNull(baseInfo?.post?.companyLegal?.legalIdNo) ? '--' : baseInfo?.post?.companyLegal?.legalIdNo }}
            </div>
          </div>
          <div
            v-if="!deepEqualField(baseInfo?.pre?.companyLegal?.idNoExpiryStartDate, baseInfo?.post?.companyLegal?.idNoExpiryStartDate) ||
              !deepEqualField(baseInfo?.pre?.companyLegal?.idNoExpiryEndDate, baseInfo?.post?.companyLegal?.idNoExpiryEndDate)" class="item"
          >
            <div class="label">
              证件有效期
            </div>
            <div class="value">
              <span>{{ isNull(baseInfo?.post?.companyLegal?.idNoExpiryStartDate) ? '--' : baseInfo?.post?.companyLegal?.idNoExpiryStartDate }}</span>
              <span> ~ </span>
              <span>{{ isNull(baseInfo?.post?.companyLegal?.idNoExpiryEndDate) ? '--' : baseInfo?.post?.companyLegal?.idNoExpiryEndDate }}</span>
              <span v-if="['29991231', '2999-12-31'].includes(baseInfo?.post?.companyLegal?.idNoExpiryEndDate)">长期</span>
            </div>
          </div>
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLegal?.idNoFrontUrl, baseInfo?.post?.companyLegal?.idNoFrontUrl)" class="item">
            <div class="label">
              身份证人像面
            </div>
            <div class="value">
              <div class="id-card-box">
                <img :src="baseInfo?.post?.companyLegal?.idNoFrontUrl">
              </div>
            </div>
          </div>
          <div v-if="!deepEqualField(baseInfo?.pre?.companyLegal?.idNoBackUrl, baseInfo?.post?.companyLegal?.idNoBackUrl)" class="item">
            <div class="label">
              身份证国徽面
            </div>
            <div class="value">
              <div class="id-card-box">
                <img :src="baseInfo?.post?.companyLegal?.idNoBackUrl">
              </div>
            </div>
          </div>
        </div>
      </template>
    </change-record-container>
  </div>
</template>

<script setup lang="ts">
import { deepEqualField, isNull } from '@core/tools';
import ChangeRecordContainer from './change-record-container.vue';
import { useElementImgPreview } from '@vue3/components';
import { ECompanyType, ICompanyChangeRecord } from '@core/main/types';
import { computed, inject, Ref, ref } from 'vue';

defineOptions({ name: 'LegalPersonInfo' }); // 账户中心 - 法人信息

const domRef = ref<HTMLDivElement>();

const isCompany = computed(() => baseInfo?.value?.post?.companyBase?.type === ECompanyType.Company);
const companyTypeText = computed(() => isCompany.value ? '法人' : '经营者');

useElementImgPreview(domRef);

defineProps({
  marginBottom: {
    type: Boolean,
    default: false,
  },
});

const baseInfo = inject<Ref<ICompanyChangeRecord>>('baseInfo');
</script>
